export default "__VITE_ASSET__DMwTylOt__"